import React, { Component } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';

import { QuizService } from 'modules/content/quiz';
import PropTypes from 'prop-types';

import DroppableComponent from './DroppableComponent';

import './SortableComponent.scss';

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);

  result.splice(endIndex, 0, removed);
  result[startIndex].order = startIndex + 1;
  result[endIndex].order = endIndex + 1;

  return result;
};

export default class DragDropComponent extends Component {
  static propTypes = {
    QuizStore: PropTypes.object,
    type: PropTypes.string,
    droppableId: PropTypes.string,
    items: PropTypes.array,
    quizType: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    if (result.type.indexOf('question') >= 0) {
      const items = this.changePosition(result);

      QuizService.updateQuizQuestions(items);
    } else if (result.type.indexOf('answer') >= 0) {
      const items = this.props.items;
      const questionId = result.type.split('-')[1];
      const questionIndex = items.findIndex((item) => item.id === questionId);

      if (questionIndex >= 0) {
        const list = items[questionIndex].answers;
        const answers = reorder(
          list,
          result.source.index,
          result.destination.index
        );

        items[questionIndex].answers = answers;
        QuizService.updateQuizQuestions(items);
      }
    } else if (result.type.indexOf('profiles') >= 0) {
      const items = this.changePosition(result);

      QuizService.updateQuizProfiles(items);
    }
  }

  changePosition(result) {
    const destination = result.destination.index;
    const begin = result.source.index;

    return reorder([...this.props.items], begin, destination);
  }

  render() {
    const { items, type, quizType } = this.props;
    const componentFormat = type === 'question' ? 'quiz' : 'profiles';

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <DroppableComponent
          type={type}
          componentFormat={componentFormat}
          items={items}
          droppableId={this.props.droppableId}
          quizType={quizType}
        />
      </DragDropContext>
    );
  }
}
